export enum RugbyUnionRuckAttribute {
  Won = 2977,
  Lost = 2978,
}
